import VueRouter from 'vue-router'
import store from '../store';
import {setAuth, getAuth, getMenus} from '../services/auth';
import routeDefs from './routeConfig';

export const getRouteDefs = () => routeDefs;

const router = new VueRouter({
    mode: 'history',
    routes: routeDefs,
});

router.beforeEach((to, from, next) => {
    const {roleId, homePageId} = getAuth();
    const home = (getRouteDefs().find(d => d.name === homePageId) || {path: ''}).path;
    const authenticated = !!roleId;
    const menus = getMenus();
    const {name, path} = to;
    if (name === 'forbidden' || name === 'error' || name === 'noFound') {
        store.commit('resetLoading');
    }

    if (name === 'sso') {
        const {t} = to.query;
        if (t) {
            try {
                setAuth(window.atob(t));
                next(home);
            } catch {
                next({name: 'forbidden'});
            }
        } else {
            next({name: 'forbidden'});
        }
    } else if (!authenticated) {
        if (name === 'login') {
            next();
        } else {
            next({
                path: '/login',
                query: {redirect: to.fullPath}
            });
        }
    } else {
        if (name === 'asterisk') {
            if (Array.from(path).some(p => p !== '/')) {
                next({name: 'noFound'});
            } else {
                next(home);
            }
        } else if (name === 'login' || name === 'root') { //觸發回首頁
            next(home);
        } else {
            if (to.matched.some(m => m.meta.requiresAuth)) {
                if (isAllow(name, menus)) {
                    next();
                } else {
                    next({name: 'forbidden'});
                }
            } else {
                next();
            }
        }
    }
});

function isAllow(menuId = '', menus = []) {
    if (menus.some(m => m.menuId === menuId)) return true;
    for (let m of menus) {
        if (isAllow(menuId, m.subMenus)) {
            return true;
        }
    }
    return false;
}

export function getTitle(menuId = '', menus = []) {
    const find = menus.find(m => m.menuId === menuId);
    if (find) return find.title;

    for (let m of menus) {
        const subFind = getTitle(menuId, m.subMenus);
        if (subFind) {
            return subFind;
        }
    }
    return '';
}

export default router;